import {postReportsDetailAdminMemo} from "../../../../../communication_system/axios_apis/axios_apis";
import createPutRequestThunk from "../../redux_functions/create_put_request_thunk";
import {PUT_REPORTS_DETAIL_ADMIN_MEMO} from "./reports_detail_type";

export const postReportsDetailAdminMemoAsync = createPutRequestThunk(
  PUT_REPORTS_DETAIL_ADMIN_MEMO,
  postReportsDetailAdminMemo
);
